import { render, staticRenderFns } from "./KiraSozlesmesiTahliyeTaahhuduAlacakFormWizard.vue?vue&type=template&id=63e22ee9"
import script from "./KiraSozlesmesiTahliyeTaahhuduAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./KiraSozlesmesiTahliyeTaahhuduAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports